import { type ChangeEvent, SelectHTMLAttributes, useCallback } from 'react';
import { containerBaseClass, labelBaseClass, selectBaseClass } from './dropdownStyles';

type DropdownProps = {
  id: string;
  name: string;
  value: string;
  label?: string;
  options: { label: string; value: string }[];
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  containerClassName?: string;
  labelClassName?: string;
} & Omit<
  SelectHTMLAttributes<HTMLSelectElement>,
  'onChange' | 'name' | 'id' | 'value' | 'className' | 'disabled'
>;

export function Dropdown({
  id,
  value,
  name,
  label,
  options,
  onChange,
  disabled,
  className = selectBaseClass,
  containerClassName = containerBaseClass,
  labelClassName = labelBaseClass,
  ...selectProps
}: DropdownProps) {
  const handleOnChange = useCallback(
    (event: ChangeEvent<HTMLSelectElement>) => {
      onChange(event.target.value);
    },
    [onChange],
  );

  return (
    <div className={containerClassName}>
      {label && (
        <label htmlFor={id} className={labelClassName}>
          {label}
        </label>
      )}
      <select
        id={id}
        name={name}
        value={value}
        onChange={handleOnChange}
        disabled={disabled}
        className={className}
        {...selectProps}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
